export class SearchResultMeta {
  public qTime: number;
  public resultCount: number;
  public numFound: number;
  public start: number;

  constructor(solrResults: any) {
    this.qTime = solrResults.responseHeader.QTime;
    this.resultCount = solrResults.response.docs.length;
    this.numFound = solrResults.response.numFound;
    this.start = solrResults.response.start;
  }
}
